var map = {
	"./issuer.ajax.json": "../../../config/ssi-demo-configs/oid4vci-demo/issuer.ajax.json",
	"./rp.ajax.json": "../../../config/ssi-demo-configs/oid4vci-demo/rp.ajax.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/configs sync recursive ^\\.\\/.*\\.json$";